import { CommonModule } from '@angular/common';
import { Component, HostListener, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormRenderComponent } from '../../../shared/widgets/form-render/form-render.component';
import { WorkerService } from '../../../api/services/worker.service';
import { WorkflowService } from '../../../api/services/workflow.service';
import { PageMetaService } from '../../../api/services/page-meta.service';
import { CardTypeTenComponent } from '../../../shared/components/card-type-ten/card-type-ten.component';
import { FORM_ID } from '../../../helpers/form-id.enum';
import { ModalRendererComponent } from '../../../shared/widgets/modal-renderer/modal-renderer.component';
import { LocationCardComponent } from '../../../shared/components/location-card/location-card.component';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormRenderComponent,
    CardTypeTenComponent,
    ModalRendererComponent,
    LocationCardComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
})
export class SettingsComponent {
  activeTab = 'organization';
  isBtnShow: boolean = true;
  nodeId: any;
  recordId: any;
  disableFields: boolean = true;
  activeModalContext: any;
  currentOpenModalId: any;
  modalTitle: any;
  searchInput: any;
  tableHeader: string = 'Business Unit';
  @ViewChild(CardTypeTenComponent) businessUnit!: CardTypeTenComponent;
  @ViewChild(LocationCardComponent) locations!: LocationCardComponent;
  searchInputs: any;
  constructor(
    private workerService: WorkerService,
    private workflowService: WorkflowService,
    private pageMeta: PageMetaService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['tab']) {
        this.activeTab = params['tab'];
      }
    });
    this.loadWorkflow('68c3ed3d45a7a695efb493f5');
    this.workerService.startWorker(localStorage.getItem('accessToken'));
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }

  loadWorkflow(wId: any, nodeId?: any): void {
    this.workflowService.loadWorkflow(wId).subscribe({
      next: ({ workflowData, recordId }) => {
        this.nodeId = nodeId || workflowData.nodes?.[0]?._id;
        this.recordId = workflowData.nodes?.[0]?.recordId;
      },
      error: (error) => {
      },
    });
  }

  openModal(type: string) {
    this.currentOpenModalId = 'open_modal';
    const fieldDeps = [
      {
        trigger: 'onClick',
        condition: [
          {
            conditions: [
              {
                type: 'modal',
                targetType: 'form',
                targetValue:
                  this.activeTab == 'business-unit'
                    ? FORM_ID.BU_ADD
                    : FORM_ID.LOCATION_ADD,
              },
            ],
          },
        ],
      },
    ];
    const onClickDep = fieldDeps.find((dep: any) => dep.trigger === 'onClick');

    if (onClickDep && Array.isArray(onClickDep.condition)) {
      for (const condBlock of onClickDep.condition) {
        const modalCond = condBlock.conditions?.find(
          (c: any) =>
            c.type === 'modal' && c.targetType === 'form' && c.targetValue,
        );

        if (modalCond) {
          this.activeModalContext = {
            nodeId: modalCond.targetValue,
            recordID: 'add',
            status: 'Active',
            type: type,
          };
          const modal = document.getElementById('open_modal');
          if (modal) modal.classList.add('show');
          return;
        }
      }
    }
  }

  closeOnBackdropClick(event: MouseEvent, modalId: any) {
    const modal = document.getElementById(modalId);
    if (event.target === modal) {
      this.closeModal();
    }
  }

  closeModal() {
    const modal = document.getElementById('open_modal');
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
  }

  /** Function to set the modal title */
  setModalTitle(title: any) {
    this.modalTitle = title;
  }

  onKeyUpSearch(searchInput: string) {
    if (searchInput.length >= 3 || searchInput.length === 0) {
      this.searchInput = (searchInput || '').trim();

      const formId = FORM_ID.BU_LIST;
      this.businessUnit.loadData(formId, {
        query: this.searchInput,
        sort: '-createdAt',
      });
    }
  }
  clearSearch(searchInputField: any) {
    searchInputField.value = '';
    this.searchInput = '';
    this.onKeyUpSearch('');
  }
  onKeyUpSearchs(searchInput: string) {
    if (searchInput.length >= 3 || searchInput.length === 0) {
      this.searchInputs = (searchInput || '').trim();
      const formId = FORM_ID.LOCATION_LIST;
      this.locations.loadData(formId, {
        query: this.searchInputs,
        sort: '-createdAt',
      });
    }
  }
  clearSearchs(searchInputField: any) {
    searchInputField.value = '';
    this.searchInputs = '';
    this.onKeyUpSearchs('');
  }

  onModalFormSaved(event: any, type: string): void {
    if (event?.success) {
      // ✅ Close modal
      if (this.currentOpenModalId) {
        const modal = document.getElementById(this.currentOpenModalId);
        if (modal) {
          modal.classList.remove('show');
        }
      }

      setTimeout(() => {
        if (this.locations) {
          this.locations.loadData(FORM_ID.LOCATION_LIST, {
            query: this.searchInputs,
            sort: '-createdAt',
          });
        } else if (this.businessUnit) {
          this.businessUnit.loadData(FORM_ID.BU_LIST, {
            query: this.searchInput,
            sort: '-createdAt',
          });
        }
      }, 500);

      this.activeModalContext = null;
      this.currentOpenModalId = null;
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: any) {
    this.closeModal();
  }
}
